(function () {
  'use strict';

  if (window.BBProductTabletLayout) {
    window.BBProductTabletLayout.init(document);
    return;
  }

  var records = new Map();
  var frame = null;
  var infoSelector = '.bb-product__info,.bb-lp__info,.bb-adh__info,.bb-sp__info,.bb-bp__info';

  function mode() {
    var width = window.innerWidth;
    if (width < 600 || width > 1366) return 'default';
    return width >= 950 && width > window.innerHeight ? 'split' : 'stack';
  }

  function moveHeading(record, destination) {
    var focused = document.activeElement;
    var preserveFocus = record.parts.some(function (part) { return part.node.contains(focused); });
    record.parts.forEach(function (part) {
      if (destination === 'stack') record.heading.appendChild(part.node);
      else if (part.marker.parentNode) part.marker.after(part.node);
    });
    if (preserveFocus && document.activeElement !== focused) focused.focus({preventScroll: true});
  }

  function update(record, nextMode) {
    if (record.mode === nextMode) return;
    moveHeading(record, nextMode);
    record.root.dataset.bbPdpLayout = nextMode;
    record.mode = nextMode;
  }

  function destroy(record) {
    moveHeading(record, 'default');
    record.parts.forEach(function (part) { part.marker.remove(); });
    record.heading.remove();
    record.info.classList.remove('bb-product__tablet-info');
    record.root.removeAttribute('data-bb-responsive-pdp');
    record.root.removeAttribute('data-bb-pdp-layout');
    records.delete(record.root);
  }

  function init(scope) {
    var candidates = Array.from(scope.querySelectorAll('.bb-product'));
    if (scope.matches && scope.matches('.bb-product')) candidates.unshift(scope);
    candidates.forEach(function (root) {
      if (records.has(root) || root.parentElement.closest('.bb-product')) return;
      var layout = root.querySelector('.bb-product__layout');
      if (!layout || layout.closest('.bb-product') !== root) return;
      var gallery = Array.from(layout.children).find(function (node) { return node.matches('[data-bb-product-gallery]'); });
      var info = Array.from(layout.children).find(function (node) { return node.matches(infoSelector); });
      if (!gallery || !info) return;

      var heading = document.createElement('div');
      heading.className = 'bb-product__tablet-heading';
      gallery.before(heading);
      var parts = ['.bb-product__title', '.bb-product__badges', '.bb-product__rating'].map(function (selector) {
        var node = info.querySelector(selector);
        if (!node) return null;
        var marker = document.createComment('PDP heading original position');
        node.before(marker);
        return {node: node, marker: marker};
      }).filter(Boolean);
      var record = {root: root, info: info, heading: heading, parts: parts, mode: null};
      info.classList.add('bb-product__tablet-info');
      root.setAttribute('data-bb-responsive-pdp', '');
      records.set(root, record);
      update(record, mode());
    });
  }

  window.addEventListener('resize', function () {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      var nextMode = mode();
      records.forEach(function (record) {
        if (!record.root.isConnected) destroy(record);
        else update(record, nextMode);
      });
    });
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (record) {
      if (event.target.contains(record.root)) destroy(record);
    });
  });
  window.BBProductTabletLayout = {init: init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once: true});
  else init(document);
}());
